const t = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="t2-icon--open-caret-left-dark-16px" viewBox="0 0 9 15">\r
<title>open caret left dark 16px</title>\r
<g class="nc-icon-wrapper">\r
<path d="M2.414 7.5l5.793 5.793a1 1 0 0 1-1.414 1.414l-6.5-6.5a1 1 0 0 1 0-1.414l6.5-6.5a1 1 0 1 1 1.414 1.414L2.414 7.5z"/>\r
</g>\r
</svg>\r`;
export {
  t as default
};
